
import React, { useState } from 'react';
import confetti from 'canvas-confetti';
import AnimatedSection from './AnimatedSection.tsx';

const LootBox: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVibrating, setIsVibrating] = useState(false);

  const handleLootBoxClick = () => {
    setIsVibrating(true);
    setTimeout(() => setIsVibrating(false), 200);

    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 100 };

    const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) {
        return clearInterval(interval);
      }
      const particleCount = 50 * (timeLeft / duration);
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);

    setTimeout(() => {
      setIsModalOpen(true);
    }, 1000);
  };

  return (
    <>
      <AnimatedSection className="w-full flex flex-col items-center">
        <h3 className="text-3xl font-bold mb-6 neon-text-cyan">BONUS LEVEL: LOOT BOX</h3>
        <button
          onClick={handleLootBoxClick}
          aria-label="Open Loot Box"
          className={`relative px-12 py-6 text-2xl font-black uppercase tracking-widest text-white border-2 border-neon-purple rounded-lg transition-all duration-300 ease-in-out hover:bg-neon-purple hover:text-black hover:shadow-[0_0_25px_#8a2be2] focus:outline-none focus:ring-4 focus:ring-neon-purple/50 ${isVibrating ? 'animate-vibrate' : ''}`}
        >
          <span className="absolute -top-2 -left-2 w-4 h-4 border-t-2 border-l-2 border-neon-cyan"></span>
          <span className="absolute -top-2 -right-2 w-4 h-4 border-t-2 border-r-2 border-neon-cyan"></span>
          <span className="absolute -bottom-2 -left-2 w-4 h-4 border-b-2 border-l-2 border-neon-cyan"></span>
          <span className="absolute -bottom-2 -right-2 w-4 h-4 border-b-2 border-r-2 border-neon-cyan"></span>
          Открыть
        </button>
      </AnimatedSection>

      {isModalOpen && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50"
          onClick={() => setIsModalOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <div 
            className="relative bg-gray-900/70 text-center p-8 m-4 rounded-xl border-2 border-neon-purple neon-box-purple max-w-lg w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-3 text-3xl text-gray-400 hover:text-white transition-colors"
              aria-label="Close modal"
            >&times;</button>
            <h4 className="text-2xl md:text-3xl font-bold text-neon-cyan neon-text-cyan mb-4">Поздравляем!</h4>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Гриша, твой главный квест на этот год — быть лучшей версией себя! Твой подарок ждет тебя в реальности!
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LootBox;
